//@flow
import * as React from 'react';
import { themr, type ThemeType } from 'react-css-themr';
import StringUtils from 'common/utils/StringUtils';
import compose from 'recompose/compose';
import { EnhancedField } from 'common/components/core/form/Field';
import { translate, type TFunction } from 'react-i18next';
import type { List } from 'immutable';
import entityIds from 'common/tests/entity/entityIds.json';

import defaultTheme from 'common/entity/generic/ExportEmailComponent.scss';

/**
 * TODO: TEMPORARY CHANGE TILL DOMAIN VALIDATION LIST CORRECTION FROM BE
import { connect } from 'react-redux';
import { getClientDomains } from 'common/redux/selectors/clientSelector';
import { HelpTooltip } from 'components/core/help';
import { PopoverPlaceEnum } from 'components/core/popover/popOverFactory';
*/

type State = {
    emailError: ?string
};

type OwnProps = {
    email: string,
    domains?: List<string>,
    error?: string,
    onChange?: (value: ?string) => void,
    onEmailInputValidation?: (isEmailValid: boolean) => void,
    disabled?: boolean,
    title?: string,
    placeholder?: string,
    theme?: ThemeType
};

type Props = {
    ...OwnProps,
    theme: ThemeType,
    t: TFunction
};

class ExportEmailComponent extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            emailError: null
        };
    }

    validateEmail = event => {
        const {
            target: { value }
        } = event;
        const { t, onEmailInputValidation } = this.props;
        if (value) {
            // const { domains } = this.props;
            const isValidEmail = StringUtils.isEmail(value);
            if (isValidEmail) {
                /**
                 * TODO: TEMPORARY CHANGE TILL DOMAIN VALIDATION LIST CORRECTION FROM BE


                const [emailAddress, emailDomain] = value.split('@'); // eslint-disable-line
                const isValidDomain = domains.indexOf(emailDomain) > -1;
                if (isValidDomain) {
                    onEmailInputValidation(true);
                    this.setState({ emailError: null });
                    return;
                } else {
                    this.setState({
                        emailError: t('entityExport.domainErrorMessage')
                    });
                    onEmailInputValidation(false);
                    return;
                }

                */

                onEmailInputValidation?.(true);
                this.setState({ emailError: null });
                return;
            }
            onEmailInputValidation?.(false);
            this.setState({ emailError: t('entityExport.emailErrorMessage') });
            return;
        }
        onEmailInputValidation?.(false);
    };

    handleInputChange = value => {
        const { onChange } = this.props;
        onChange && onChange(value);
    };

    render() {
        const {
            theme,
            t,
            email,
            error,
            title,
            placeholder,
            disabled
        } = this.props;
        const { emailError } = this.state;

        /**
         * TODO: TEMPORARY CHANGE TILL DOMAIN VALIDATION LIST CORRECTION FROM BE

            const domainTooltip = t('entityExport.domainTooltip', {
                domains: domains && domains.splice(8).join(', '),
                remainingDomainCount:
                    domains && domains.size > 8 ? `+${domains.size - 8} more` : ''
            });
        */
        return (
            <div className={theme.exportEmailComponent}>
                <div className={theme.emailTitle}>
                    {title || t('entityExport.emailTitle')}
                </div>
                <div className={theme.flexContainer}>
                    <EnhancedField
                        testId={entityIds.inputExportEmail}
                        isVisible
                        place="right"
                        element={'input'}
                        autoFocus
                        error={error || emailError}
                        popOverClassName={theme.popOverClassName}
                        theme={theme}
                        className={theme.emailInput}
                        value={email}
                        onBlur={this.validateEmail}
                        onChange={this.handleInputChange}
                        placeholder={
                            placeholder || t('entityExport.emailPlaceholder')
                        }
                        disabled={disabled}
                    />

                    {/** domains ? (
                        <HelpTooltip
                            tooltipText={domainTooltip}
                            theme={theme}
                            preferPlace={PopoverPlaceEnum.Above}
                        />
                    ) : null */}
                </div>
            </div>
        );
    }
}

/**
  * TODO: TEMPORARY CHANGE TILL DOMAIN VALIDATION LIST CORRECTION FROM BE

    const mapStateToProps = (state, props) => {
        const clientDomains = getClientDomains(state, props);


        return {
            domains: clientDomains
        };
    };
 */
export default (compose(
    // connect(mapStateToProps),
    themr('ExportEmailComponent', defaultTheme),
    translate('entityManagement')
)(ExportEmailComponent): React.AbstractComponent<OwnProps>);
